import {createSelector} from '@ngrx/store';

export const selectCustomerState = state => state.customer;

export const selectBillingAddresses = createSelector(
	selectCustomerState,
	customer => customer.billingAddresses
);

export const selectShippingAddresses = createSelector(
	selectCustomerState,
	customer => customer.shippingAddresses
);

